import { render, staticRenderFns } from "./StaffPerformance.vue?vue&type=template&id=7518400e&"
import script from "./StaffPerformance.vue?vue&type=script&lang=js&"
export * from "./StaffPerformance.vue?vue&type=script&lang=js&"
import style0 from "./StaffPerformance.vue?vue&type=style&index=0&id=7518400e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StaffPerformance.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./StaffPerformance.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QPage,QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QTable})
